<script setup>
// The "Handicap calculator" entry point — a button plus its dialog, so any competition surface
// (admin or public) can drop it in with the entrants it already has.
import {ref} from 'vue';
import HandicapCalculatorDialog from '~/components/handicaps/HandicapCalculatorDialog.vue';

defineProps({
  settings: {type: Object, default: null},
  entries: {type: Array, default: () => []},
  scoringSystemId: {type: String, default: null},
  noun: {type: String, default: 'player'},
  // americano: sides are pairs — pick two players per side
  pairs: {type: Boolean, default: false},
  size: {type: String, default: 'small'},
  variant: {type: String, default: 'outlined'},
  // public competition pages: render as one of the action-row buttons (class "as"), beside Start Chat
  action: {type: Boolean, default: false},
  // club admin: sees the calculator even while values are hidden from members
  admin: {type: Boolean, default: false},
});
const open = ref(false);
</script>

<template>
  <template v-if="settings && (settings.showToMembers !== false || admin)">
    <button v-if="action" class="as" type="button" @click="open = true">
      <v-icon size="17" icon="mdi-calculator-variant-outline"/>Handicap calculator
    </button>
    <v-btn v-else :size="size" :variant="variant" prepend-icon="mdi-calculator-variant-outline" class="text-none"
           @click="open = true">Handicap calculator</v-btn>
    <handicap-calculator-dialog v-model="open" :settings="settings" :entries="entries"
                                :scoring-system-id="scoringSystemId" :noun="noun" :pairs="pairs"/>
  </template>
</template>
